module.exports = require('./cjs/nivo-legends');